module.exports = __webpack_public_path__ + "static/media/tr.d76ac1e9.svg";